/* eslint-disable react/jsx-no-target-blank */
import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {KTIcon} from '../../../../helpers'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import {getSideBarCount} from '../../../../../API/api-endpoint'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const loginUser: any = JSON.parse(localStorage.getItem('kt-auth-react-v') || '')
  let [count, setCount] = useState<any>({})

  useEffect(() => {
    getCount()
  }, [])

  const getCount = async () => {
    let result = await getSideBarCount()
    if (result.success) {
      setCount(result.data)
    }
  }

  return (
    <>
      <SidebarMenuItem
        to='dashboard'
        icon='screen'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />
      {/* <SidebarMenuItem
        to='mdashboard'
        icon='abstract-28'
        title={intl.formatMessage({id: 'MENU.MODERATORDASHBOARD'})}
        fontIcon='bi-app-indicator'
      /> */}
      {/* <SidebarMenuItem
        to='apps/admin-user-management'
        icon='abstract-28'
        title={intl.formatMessage({id: 'MENU.ADMINUSERS'})}
        fontIcon='bi-layers'
      /> */}
      <SidebarMenuItemWithSub
        to='apps/user-management'
        title={`${intl.formatMessage({id: 'MENU.USERMANAGEMENT'})} `}
        icon='profile-user'
        fontIcon='bi-person'
      >
        <SidebarMenuItem
          to='apps/user-management/users'
          icon='people'
          title={`User List`}
          fontIcon='bi-person'
        />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='apps/store-management'
        title={`${intl.formatMessage({id: 'MENU.STOREMANAGEMENT'})}`}
        icon='shop'
        fontIcon='bi-person'
      >
        <SidebarMenuItem
          to='apps/store-management/stores'
          icon='shop'
          title={`${intl.formatMessage({id: 'MENU.STOREMANAGEMENT.ALLSTORES'})}`}
          fontIcon='bi-person'
        />
        <SidebarMenuItem
          to='apps/store-management/store-approval'
          icon='badge'
          title={`${intl.formatMessage({id: 'MENU.STOREMANAGEMENT.STOREAPPROVAL'})} (${
            count.store_approval || 0
          })`}
          fontIcon='bi-person'
        />
        <SidebarMenuItem
          to='apps/store-management/store-verification'
          icon='shield'
          title={`${intl.formatMessage({id: 'MENU.STOREMANAGEMENT.STOREVERIFICATION'})} (${
            count.store_verification || 0
          })`}
          fontIcon='bi-person'
        />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='apps/offer-management'
        title={`${intl.formatMessage({id: 'MENU.OFFERMANAGEMENT'})}`}
        icon='tag'
        fontIcon='bi-person'
      >
        <SidebarMenuItem
          to='apps/offer-management/all-offers'
          icon='discount'
          title={`${intl.formatMessage({id: 'MENU.OFFERMANAGEMENT.ALLOFFERS'})}`}
          fontIcon='bi-person'
        />
        <SidebarMenuItem
          to='apps/offer-management/offer-approval'
          icon='badge'
          title={`${intl.formatMessage({id: 'MENU.OFFERMANAGEMENT.OFFERSAPPROVAL'})} (${
            count.offer_approval || 0
          })`}
          fontIcon='bi-person'
        />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='analytics/daily-analytics'
        title={intl.formatMessage({id: 'MENU.ANALYTICS'})}
        icon='chart-simple-2'
        fontIcon='bi-person'
      >
        <SidebarMenuItem
          to='analytics/daily-analytics'
          icon='graph-up'
          title={intl.formatMessage({id: 'MENU.DAILYANALYTICS'})}
          fontIcon='bi-layers'
        />
        <SidebarMenuItem
          to='analytics/package-analytics'
          icon='chart-line'
          title={intl.formatMessage({id: 'MENU.PREMIUMANANALYTICS'})}
          fontIcon='bi-layers'
        />
        <SidebarMenuItem
          to='analytics/graphs-analytics'
          icon='chart-pie-3'
          title={intl.formatMessage({id: 'MENU.GRAPHSANALYTICS'})}
          fontIcon='bi-layers'
        />
        {/* <SidebarMenuItem
          to='analytics/offers-analytics'
          icon='abstract-28'
          title={intl.formatMessage({id: 'MENU.OFFERSANALYTICS'})}
          fontIcon='bi-layers'
        /> */}
      </SidebarMenuItemWithSub>
      <SidebarMenuItem
        to='plugins'
        icon='switch'
        title={intl.formatMessage({id: 'MENU.PLUGINS'})}
        fontIcon='bi-layers'
      />
      <SidebarMenuItem
        to='user-order'
        icon='purchase'
        title={intl.formatMessage({id: 'MENU.USERORDER'})}
        fontIcon='bi-layers'
      />
      <SidebarMenuItem
        to='support-system'
        icon='message-question'
        title={`${intl.formatMessage({id: 'MENU.SUPPORTSYSTEM'})} (${count?.support_count || 0})`}
        fontIcon='bi-layers'
      />
      {/* <SidebarMenuItem
        to='blocked-user-management'
        icon='abstract-28'
        title={intl.formatMessage({id: 'MENU.BLOCKEDUSERS'})}
        fontIcon='bi-layers'
      /> */}
      {/* <SidebarMenuItem
        to='invoice-management'
        icon='cheque'
        title={intl.formatMessage({id: 'MENU.INVOICEMANAGEMENT'})}
        fontIcon='bi-layers'
      /> */}
    </>
  )
}

export {SidebarMenuMain}
